<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../utilities/BrowserDataUtil'
import AppResourceUtil from '../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../api/UserApi';
import IssueApi from '../api/IssueApi';
/** Constant */
import { ORE_EMAIL } from '../constants/ContactData'
/** UI Components */
import UserProfileForm from '../components/UserProfileForm'
import UserChangePasswordForm from '../components/UserChangePasswordForm'
import { Dropdown,DropdownItem } from 'buefy/dist/components/dropdown'
import { Modal } from 'buefy/dist/components/modal'
import { Icon } from 'buefy/dist/components/icon'
import { Field } from 'buefy/dist/components/field'
import { Input } from 'buefy/dist/components/input'
import { Tag } from 'buefy/dist/components/tag'

import SystemManual from '@/assets/manual/System-Manual-v2.0.pdf';
import AdminManual from '@/assets/manual/Admin-System-Manual-v2.0.pdf';
import IAManual from '@/assets/manual/Independent-Admin-System-Manual-v2.0.pdf';

const ADMIN_MANUAL_V = '2.0'
const NONADMIN_MANUAL_V = '2.0'

export default {
    name : "MainView",
    components : {
        'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,
        'b-modal' : Modal,
        'b-icon' : Icon,
        'b-field' : Field,
        'b-input' : Input,
        'b-tag' : Tag,
        'UserProfileForm' : UserProfileForm,
        'UserChangePasswordForm' : UserChangePasswordForm
    },
	computed : {
		...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        activeNavName(){
            if (this.activeNav) {
                return this.activeNav.name;
            }
            return "";
        },
        isAdminView(){
            if (this.activeNav) {
                if (this.activeNav.meta) {
                    return this.activeNav.meta.isAdminView;
                }
            }
            return false;
        },
        reportingEntity(){
            if (this.profile) {
                if (this.profile.role!=='Admin' && this.profile.role!=='Independent Administrator') {
                    if (this.profile.reportingEntites && this.profile.reportingEntites.length === 1) {
                        return this.profile.reportingEntites[0].reportingEntity;
                    }
                }
            }            
            return "Online Reporting in the Extractives";
        },
        tagClass(){
            if (this.profile) {
                if (this.profile.role!=='Admin' && this.profile.role!=='Independent Administrator') {
                    if (this.profile.reportingGroups && this.profile.reportingGroups.length === 1) {
                        return this.profile.reportingGroups[0].repGroupTagClass
                    }
                }
            }    
            return ''
        },
        tagGroup(){
            if (this.profile) {
                if (this.profile.role!=='Admin' && this.profile.role!=='Independent Administrator') {
                    if (this.profile.reportingGroups && this.profile.reportingGroups.length === 1) {
                        if (this.profile.reportingGroups[0].tagName==null) {
                            return this.profile.reportingGroups[0].reportingGroup
                        } else {
                            return this.profile.reportingGroups[0].tagName
                        }
                    }
                }
            }    
            return ''
            // if (this.profile.tagName==null) {
            //     return this.profile.reportingGroup;
            // }
            // return this.profile.tagName;
        },
        workspaceLink() {
            if (this.profile) {
                if (this.profile.role=='Admin' || this.profile.role=='Independent Administrator') {
                    return '#/preview-workspace'
                }
            }            
            return '#/workspace'
        },
        fileManual() {
            if (this.profile) {
                if (this.profile.role!='Admin' && this.profile.role!='Independent Administrator') {
                    return SystemManual;
                }
                if (this.profile.role=='Admin') {
                    return AdminManual;
                }
                return IAManual;
            }
        },
        fileManualLabel(){
            var label = 'View System Manual'
            if (this.profile) {
                if (this.profile.role!='Admin' && this.profile.role!='Independent Administrator') {
                    label += ` (Version ${NONADMIN_MANUAL_V})`
                }
                if (this.profile.role=='Admin') {
                    label += ` (Version ${ADMIN_MANUAL_V})`
                }
            }
            return label;
        },
        isSystemAdmin() {
            if (this.profile) {
                if (this.profile.fullName.match(/system admin/gi)) {
                    return true
                }
            }
            return false
        }
	},
    data(){
        return {
            isSubnavOpen : false,
            isProfileOptsOpen : false,
            showViewProfile : false,
            showChangePassword : false,
            showFeedbackForm : false,
            isIssue : false,
            feedbackData : {
                message : ""
            },
            issueCount : 0,
            issueInterval : null,
            supportEmail : ORE_EMAIL
        }
    },
    created(){
        var token = BrowserDataUtil.getBrowserData(
            this.$cookies,
            'ore-auth-key',
            this.token
        );
        if (!token) {
            this.logOut();
            return false;
        }
        else {
            this.setToken(token);
            // check if token is still valid
            this.isTokenValid(token);
        }
    },
    mounted(){
        this.$eventHub.$on('issues-updated',()=>{
            this.getIssueCount()
        });
    },
    beforeDestroy(){
        clearInterval(this.issueInterval);
        this.$eventHub.$off('issues-updated');
    },
    methods : {
        ...mapMutations({
            clearAppData : "clearAppData",
            setActiveNav : "updateActiveNav",
            setProfile : "updateUserProfile",
            setToken : "udpateAuthToken"
        }),
        isTokenValid(token){
            UserApi.isTokenValid({
                token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut(token)
                            }
                            else {
                                // Session is still active
                                this.checkProfile();
                                this.checkActiveNav();

                                if (this.profile) {
                                    if (this.profile.role=='Admin') {
                                        this.getIssueCount();
                                
                                        // Calls getIssueCount 
                                        // every 15mins
                                        this.issueInterval = setInterval(()=>{ 
                                            this.getIssueCount();
                                        }, 900000);
                                    }
                                }
                                
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        checkActiveNav(){
            var nav = BrowserDataUtil.getBrowserData(
				this.$cookies,
				'ore-nav',
				this.activeNav
            );
			if (nav==null) {
                var navData = {
                    name : this.$route.name,
                    path : this.$route.path,
                    meta : this.$route.meta
                };
                this.updateActiveNav(navData);    
            }
			else {
                this.updateActiveNav(nav);
            }
        },
        checkProfile(){
            var profile = BrowserDataUtil.getBrowserData(
				this.$cookies,
				'ore-user-profile',
                this.profile
            );
            if (!profile) {
                this.logOut();
                return false
            }
            this.setProfile(profile);
            if (this.$route.path=='/') {
                let page = "";
                switch(profile.role) {
                    case "Admin" :
                        page = '/admin-dashboard';
                        break;
                    case "Independent Administrator" :
                        page = '/ia-dashboard';
                        break;
                    case "Data Compliance Officer":
                        page = '/dashboard';
                        break;
                    case "Authorized Representative":
                        page = '/dashboard';
                        break;
                }
                this.$router.push({path: page})
            }
        },
        closeSubnav(){
            this.isSubnavOpen = false;
        },
        toggleProfileBtn(){
            this.isProfileOptsOpen = !this.isProfileOptsOpen;
        },
        toggleSubnav(){
            this.isSubnavOpen = !this.isSubnavOpen;
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {                            
                        }
                    }
                })
                .catch(error=>{
                });

                BrowserDataUtil.clearBrowserData(this.$cookies);
                this.clearAppData();
                this.$router.push({path:"/login"})
            }
            else {
                // Remove session data from client-side
                BrowserDataUtil.clearBrowserData(this.$cookies);
                this.clearAppData();
                this.$router.push({path:"/login"})
            }
        },
        openAdmin(){
            this.toggleSubnav();
        },
        changePwdFromProfile(){
            this.showViewProfile = false;
            this.showChangePassword = true;
        },
        openChangePassword(){
            this.showChangePassword = true;
        },
        closeChangePassword(){
            this.showChangePassword = false;
        },
        saveNewPassword(newPassword){
            UserApi.savePassword({
                userId : this.profile.userId,
                password : newPassword,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data.isUpdated) {
                    this.$dialog.alert({
                        title: 'Success',
                        message: "Password updated.",
                        type: 'is-success'
                    });
                }
                else {
                    this.$dialog.alert({
                        title: 'Error',
                        message: "Unable to change password at the moment. Please try again later.",
                        type: 'is-danger'
                    });
                }
                this.showChangePassword = false;
            })
            .catch(error=>{
                this.showChangePassword = false;  
                this.promptServerError(error,'User.savePassword');
            })
        },
        openProfile(){
            this.showViewProfile = true;
        },
        closeViewProfile(){
            this.showViewProfile = false;
        },
        updateActiveNav(navData){
            // Set store data
            this.setActiveNav(navData);
            // Set browser data
            BrowserDataUtil.setActiveNav(this.$cookies,navData);
        },
        sendFeedback(){
            /** 
             * Email implementation
             * return window.location.href= "mailto:"+ORE_EMAIL+"?subject=ORE Feedback from "+this.profile.fullName;
             * */
            this.showFeedbackForm = true;
            this.isIssue = false;
            this.feedbackData.message = "";
        },
        reportIssue(){
            /** 
             * Email implementation
             * return window.location.href= "mailto:"+ORE_EMAIL+"?subject=ORE Issue filed by "+this.profile.fullName; 
             * */
            this.showFeedbackForm = true;
            this.isIssue = true;
            this.feedbackData.message = "";
        },
        submitFeedback(){

            if (this.feedbackData.message.trim().length==0) {
                return false
            }

            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : this.feedbackData.message,
                issueStatus : this.isIssue ? "Pending" : "Not Applicable",
                issueType : this.isIssue ? "Issue" : "Feedback",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        let typeStr = "Thanks for your feedback!";
                        if (this.isIssue) {
                            typeStr = "Thanks for reporting!"
                        }
                        this.$dialog.alert({
                            title: 'Success',
                            message: '<p><strong>'+typeStr +"</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success',
                            onConfirm : ()=>{
                                this.closeFeedbackForm()
                            }
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit feedback. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        closeFeedbackForm(){
            this.showFeedbackForm = false;
            this.isIssue = false;
            this.feedbackData.message = "";
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }
            
            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        getIssueCount(){
            this.issueCount = 0;
            IssueApi.getUnresolvedCount()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.length > 0) {
                            let count = response.data[0].cnt;
                            this.issueCount = count;
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'Issue.getUnresolvedCount');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.getUnresolvedCount');
            });
        },
        emailUs(){
            return window.location.href= "mailto:"+ORE_EMAIL+"?subject=[ORE] | Message from: "+this.profile.fullName;
        },
        viewSystemManual(){
            window.open(this.fileManual,"", "width=1366,height=768");
        },
        viewNonAdminSystemManual(){
            window.open(SystemManual,"", "width=1366,height=768");
        }
    },
    watch : {
        $route (to, from) {
            // react to route changes...
            if (to.name) {
                var navData = {
                    name : to.name,
                    path : to.path,
                    meta : to.meta
                };
                if (to.meta) {
                    if (to.meta.isAdminView==false) {
                        this.closeSubnav();
                    }
                }
                /** Google Analytics 'Page View' */          
                try {
                    gtag('config', 'UA-177280905-1',{
                        'page_title': to.name,
                        'page_path': to.path
                    });
                } catch(gaErr){
                    console.log(' LOG >> '+gaErr)
                }
                this.updateActiveNav(navData);
            }
        }
    }
}
</script>

<template>
    <div class="columns base-box box-ht--fill" 
        id="main-wrapper">
        <section class="column base-box base-box--tbpadded box-ht--fill" 
            id="sidenav-wrapper">
            <nav class="has-text-centered"
                id="main-nav">
                <div class="box-wd--fill logo-box">
                    <img 
                        src="static/img/Logo.jpg" />
                    <p 
                        v-if="profile && (profile.role!=='Admin' && profile.role!=='Independent Admininistrator')"
                        class="title is-4 has-text-white app-title">ORE</p>
                </div>
                <!-- Dashboard -->
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Dashboard"
                    href="#/admin-dashboard"
                    v-if="profile && profile.role=='Admin'"
                    v-bind:class="{'active-nav':activeNavName=='Admin Dashboard'}">
                    <span class="icon">
                        <i class="fas fa-desktop"></i>
                    </span>
                </a>
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Dashboard"
                    href="#/ia-dashboard"
                    v-if="profile && profile.role=='Independent Administrator'"
                    v-bind:class="{'active-nav':activeNavName=='IA Dashboard'}">
                    <span class="icon">
                        <i class="fas fa-desktop"></i>
                    </span>
                </a>
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Dashboard"
                    href="#/dashboard"
                    v-if="profile && profile.role!='Admin' && profile.role!='Independent Administrator'"
                    v-bind:class="{'active-nav':activeNavName=='Dashboard'}">
                    <span class="icon">
                        <i class="fas fa-desktop"></i>
                    </span>
                </a>
                <!-- Workspace -->
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Workspace"
                    v-bind:href="workspaceLink"
                    v-bind:class="{'active-nav':activeNavName=='Workspace' || activeNavName=='Workspace Preview'}">
                    <span class="icon">
                        <i class="fas fa-pencil-ruler"></i>
                    </span>
                </a>
                <!-- Summary -->
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Summary"
                    href="#/summary"
                    v-bind:class="{'active-nav':activeNavName=='Summary'}">
                    <span class="icon">
                        <i class="fas fa-file-alt"></i>
                    </span>
                </a>
                <!-- Reporting -->
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Report"
                    href="#/report"
                    v-if="profile && (profile.role=='Admin' || profile.role=='Independent Administrator')"
                    v-bind:class="{'active-nav':activeNavName=='Report'}">
                    <span class="icon">
                        <i class="fas fa-chart-line"></i>
                    </span>
                </a>
                <!-- Administration -->
                
                <a class="button is-white is-large tooltip is-tooltip-right"
                    data-tooltip="Administration"
                    v-if="profile && profile.role=='Admin'"
                    v-bind:class="{'active-nav':isAdminView}"
                    v-on:click="toggleSubnav">
                    <span class="icon">
                        <i class="fas fa-cog"></i>
                        <div class="alert-circle"
                            v-if="issueCount > 0"></div>
                        <!-- <b-tag
                            type="is-danger" 
                            rounded>
                            {{issueCount}}
                        </b-tag> -->
                    </span>
                </a>
            </nav>
            <!-- Sub-nav -->
            <nav id="sub-nav"
                v-bind:class="{'sub-nav--open':isSubnavOpen==true,'sub-nav--closed':isSubnavOpen==false}">
                <p class="menu-label">Administration</p>
                <ul class="menu-list">
                    <li v-bind:class="{'active-subnav':activeNavName=='Reporting Groups'}">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/reporting-groups">
                            Reporting Groups
                        </a>
                    </li>
                    <li v-bind:class="{'active-subnav':activeNavName=='Forms'}">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/forms">
                            Forms
                        </a>
                    </li>
                    <li v-bind:class="{'active-subnav':activeNavName=='Users'}">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/users">
                            Users
                        </a>
                    </li>
                    <li v-bind:class="{'active-subnav':activeNavName=='Issues'}"
                        style="display:flex;">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/issues">
                            Feedback & Issues
                        </a>
                        <b-tag
                            v-if="issueCount > 0"
                            type="is-danger" 
                            rounded
                            style="margin-top:0.4rem">
                            {{issueCount}}
                        </b-tag>
                    </li>
                    <li v-bind:class="{'active-subnav':activeNavName=='Announcements'}">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/announcements">
                            Announcements
                        </a>
                    </li>
                    <li v-if="isSystemAdmin"
                        v-bind:class="{'active-subnav':activeNavName=='Cards and Access'}">
                        <a 
                            v-on:click="openAdmin"
                            href="#/admin/vcards">
                            Cards and Access
                        </a>
                    </li>
                </ul>
            </nav>
        </section>
        <section class="column base-box box-ht--fill"
            id="content-wrapper">
            <nav class="navbar columns">
                <section class="column">
                    <!-- Reporting Group / Unit Info -->
                    <h1 class="subtitle is-4 reporting-group-name">
                        {{reportingEntity}}
                        <span class="tag"
                            v-if="profile && tagClass !== ''"
                            v-bind:class="tagClass">{{tagGroup}}</span>
                    </h1>
                </section>
                <section class="column is-4 has-text-right">
                     <b-dropdown aria-role="list">
                        <button 
                            class="button is-light" slot="trigger">
                            <span class="icon">
                                <i class="fas fa-cog"></i>
                            </span>
                            <span>Account</span>
                            <b-icon icon="menu-down"></b-icon>
                        </button>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="openProfile">
                            <span class="icon">
                                <i class="fas fa-user"></i>
                            </span>
                            View Profile
                        </b-dropdown-item>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="openChangePassword">
                            <span class="icon">
                                <i class="fas fa-unlock-alt"></i>
                            </span>
                            Change Password
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown aria-role="list">
                        <button 
                            class="button is-light" slot="trigger">
                            <span class="icon">
                                <i class="fas fa-question-circle"></i>
                            </span>
                            <span>Help</span>
                            <b-icon icon="menu-down"></b-icon>
                        </button>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="sendFeedback">
                            Send Feedback
                        </b-dropdown-item>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="reportIssue">
                            Report an issue
                        </b-dropdown-item>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="emailUs">
                            Email Us <br/>{{supportEmail}}
                        </b-dropdown-item>
                        <hr class="dropdown-divider">
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-on:click="viewSystemManual">
                            {{fileManualLabel}}
                        </b-dropdown-item>
                        <b-dropdown-item 
                            aria-role="listitem"
                            v-if="profile && profile.role=='Admin'"
                            v-on:click="viewNonAdminSystemManual">
                            View System Manual (for DCO/AR)
                        </b-dropdown-item>
                    </b-dropdown>
                   
                    <div class="separator-v"></div>

                    <button 
                        class="button is-light"
                        v-on:click="logOut">
                        <span class="icon">
                            <i class="fas fa-sign-out-alt"></i>
                        </span>
                        <span>Log out</span>
                    </button>
                </section>
            </nav>
            <section class="column box-ht--fill" 
                id="view-wrapper">
                <router-view name="main"></router-view>
            </section>
        </section>
        <!-- Modal: View My Profile -->
        <b-modal
            v-bind:active.sync="showViewProfile"
            v-bind:width="640"
            v-on:close="closeViewProfile">
            <UserProfileForm
                v-on:close="closeViewProfile"
                v-on:change-pass="changePwdFromProfile"
                v-bind:userProfile="profile"/>
        </b-modal>

        <!-- Modal: Change Password -->
        <b-modal
            v-bind:active.sync="showChangePassword"
            v-bind:width="640"
            v-on:close="closeChangePassword">
            <UserChangePasswordForm
                v-on:close="closeChangePassword"
                v-on:submit="saveNewPassword"
                v-bind:userProfile="profile"/>
        </b-modal>

        <!-- Modal: Feedback/Issue -->
        <b-modal
            v-bind:active.sync="showFeedbackForm"
            v-bind:width="640"
            v-on:close="closeFeedbackForm">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{isIssue ? 'Report an Issue' : 'Send Feedback'}}
                    </p>
                </header>
                <section class="modal-card-body">
                    <p>Please provide details below.</p><br/>
                    <b-field
                        label="Description"
                        expanded>
                        <b-input 
                            v-model="feedbackData.message"
                            maxlength="200" 
                            type="textarea"
                            required></b-input>
                    </b-field>
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="closeFeedbackForm">
                        <span>Cancel</span>
                    </a>

                    <a class="button is-success"
                        v-on:click="submitFeedback"
                        v-bind:disabled="feedbackData.message.trim().length < 5">
                        <span>Submit</span>
                    </a>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<style scoped>
#main-wrapper,
#content-wrapper{
    margin: 0;
    padding: 0;
}
.navbar {
    background: whitesmoke;
    padding:0;
    margin:0;
}
#sidenav-wrapper {
    /* background-color:#03284e; */
    background-color:#092257; /*#33475d;*/
    height: 100%;
    min-width: 70px;
    max-width: 70px;
    padding: 0;
    margin: 0;
    position: relative;
}
#main-nav {    
    width: 100%;
    text-align: center;
    margin: auto;
    display: flex;
    flex-direction: column;
}
#main-nav > .button {
    /* width: 50px; */
    /* height: 48px; */
    display: block;
    margin: auto;
    margin-top: 0.38rem;
    background: transparent;
}
#main-nav > .button:hover {
    /* background-color: #213347; */
    background-color:#123071;
}
#main-nav > .button.active-nav {
    background-color: #3db4f8;
    outline: none;
}
#main-nav > .button > .icon {
    color: #fff;
}
/* Collapsible Navigation */
#sub-nav {
    /* background-color:#083a6b; */
    /* background-color: #3e5369; */
    background-color:#0e2b6a;
    position: absolute;
    top: 25%;
    left: 70px;
    transition: ease-in;
    transition-duration: 0.1s;
    max-width:250px;
    width: 225px;
    height: auto;
    text-align: left;
    display: flex;
    flex-direction: column;
    padding-right: 0.65em;
    padding-top: 0.85em;
    z-index: 1; /*to increase b-collapse*/
}
.sub-nav--closed {
    visibility: hidden;
}
.sub-nav--open {
    visibility:visible;
}
#sub-nav .menu-label {
    font-weight: 600;
    margin-left: 1em;
    color: rgb(182, 182, 182);
}
#sub-nav ul {
    padding: 0;
    margin: 0;
    margin-left: 0.25em;
    padding-bottom: 0.5em;
    color: #fff;
}
#sub-nav li {
    padding: 0.45em;
    text-align: left;
    justify-content:flex-start;
    position: relative;
    margin-top: 0.25em;
    border-radius: 6px;
    color: #fff;
}
#sub-nav li a {
    color: #fff;
}
#sub-nav li:hover,
#sub-nav li:hover > a {
    /* background-color: #042647c2; */
    /* background-color: #2a3d52; */
    background-color:#193d8a;
}
.active-subnav {
    /* background-color: #042647c2; */
    /* background-color: #2a3d52; */
    background-color:#193d8a;
}
.logo-box {
    /* background-color: #2a3d52; */
    background-color:#092257;
}
.reporting-group-name {
    margin-left: 0.35em;
    margin-top: 0.2em;
    /* font-weight: 500; */
}
.separator-v {
    display: inline-block;
    width:2px;
    height:17px;
    margin:0.6rem auto;
    margin-left: 0.7rem;
    margin-right: 0.7rem;
    border:none;
    border-right: 1px solid #ccc;
}
.alert-circle {
    background-color: #ff3860;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-flex;
    display:-webkit-inline-box;
    position:absolute;
    top: 7px;
    right: 7px;
}
</style>




// WEBPACK FOOTER //
// src/views/MainView.vue